import { PanelMenu } from "primereact/panelmenu";
import React from "react";
import './style.scss';

const EmployeePage = () => {

  const items = [
    {
      label: 'Store',
      icon: 'pi pi-user',
      items: [
        {
          label: 'Documents',
          icon: 'pi pi-file',
        },
      ]
    },
    {
      label: 'Customer',
      icon: 'pi pi-user',
      items: [
        {
          label: 'Upload',
          icon: 'pi pi-cloud-upload'
        }
      ]
    },
    {
      label: 'Earnings',
      icon: 'pi pi-desktop',
      items: [
        {
          label: 'Phone',
          icon: 'pi pi-mobile'
        }
      ]
    }
  ];
  return (
    <>
      <section className='shopkeeper-page'>
        <div className="container">
          <PanelMenu model={items} className="w-full" />
        </div>
      </section>

    </>
  )
}

export default EmployeePage